import React, { useEffect, useState, useRef, useContext } from "react";
import Pagination from '../../components/pagination/pagination';
import ViewLayout from "../../components/viewLayout";
import { useFetch } from "../../utils/fetchHook";
import { StateContext } from "../../utils/context";

import DeploymentCreditsTable from "../../components/deploymentCreditsTable";

import { getCookie } from "../../jwt/_helpers/cookie";
import TableHelper from "../../components/tableHelper";

const DeploymentCredits = props => {
  const token = getCookie("token");
  const {currentUser} = useContext(StateContext);

  const didEff1 = useRef(false);
  const didEff2 = useRef(false);

  const [forceUpdate, setForce] = useState(1);
  const [tableData, setTableData] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [currrentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [query, setQuery] = useState('');
  const [ordering, setOrdering] = useState({order: '', name: 'name', sort: 'name'});

  const [apiData, error, loading] = useFetch(
    "GET",
    `deployment-credits/?ordering=${ordering.order + ordering.name}&page=${currrentPage}&page_size=${pageSize}&query=${query}`,
    token,
    false,
    forceUpdate
  );

  const defaultSorted = [{
    dataField: ordering.sort,
    order: ordering.order === "-" ? "desc" : "asc"
  }] 

  const tableProps = {
    tableData,
    defaultSorted
  };

  useEffect(() => {
    if (apiData?.detail === "Invalid page.") {
      setCurrentPage(1);
      return;
    }

    if (apiData) {
      if(apiData.count) {
        setDataCount(apiData.count);
      }
      if(apiData.results) {
        setTableData(apiData.results);
      }
    }
  }, [apiData]);

  
  useEffect(() => {
    if (!didEff1.current) {
      didEff1.current = true;
      return;
    }
    setForce(prev => prev + 1);
  }, [currrentPage, pageSize, ordering.order, ordering.name]);


  useEffect(() => {
    if (!didEff2.current) {
      didEff2.current = true;
      return;
    }
    const timeout = setTimeout(() => {
      setForce(prev => prev + 1);
    }, 500)
    return () => clearTimeout(timeout)
  }, [query])

  const paginationProps = {
    pageSize, setPageSize, dataCount, setCurrentPage, currrentPage
  }

  return (
    <>
      {loading ? (
        <TableHelper loading />
      ) : error ? (
        <TableHelper error />
      ) :  (
        <div>
        <ViewLayout title={"Deployment Credits History"}>
        <DeploymentCreditsTable
            {...tableProps}
            forceUpdate={forceUpdate}
            searchQuery={{setQuery, query, ordering, setOrdering}}
        />
        </ViewLayout>
        <Pagination pagination={paginationProps}/>
        </div>
      )}
    </>
  );
};

export default DeploymentCredits;
